import { memo } from 'react'
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline'

/**
 * CollapsibleSection - Reusable collapsible section with header
 * Provides consistent styling and behavior for expandable sections
 */
const CollapsibleSection = memo(function CollapsibleSection({
  title,
  icon: Icon,
  count,
  isExpanded,
  onToggle,
  tooltip,
  iconColor = 'text-primary-400',
  badgeColor = 'bg-primary-100 text-primary-700',
  children
}) {
  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-md overflow-hidden border border-gray-200/50">
      <button
        onClick={onToggle}
        className="w-full px-2.5 py-1.5 flex items-center justify-between hover:bg-white/90 transition-colors group"
        title={tooltip}
      >
        <div className="flex items-center gap-1.5">
          <Icon className={`h-3.5 w-3.5 ${iconColor}`} />
          <span className="font-medium text-xs text-gray-700">{title}</span>
          {count > 0 && (
            <span className={`px-1.5 py-0.5 text-xs font-semibold rounded-full ${badgeColor}`}>
              {count}
            </span>
          )}
        </div>
        {isExpanded ? (
          <ChevronUpIcon className="h-3 w-3 text-gray-400 group-hover:text-gray-600 transition-colors" />
        ) : (
          <ChevronDownIcon className="h-3 w-3 text-gray-400 group-hover:text-gray-600 transition-colors" />
        )}
      </button>

      {isExpanded && (
        <div className="border-t">
          {children}
        </div>
      )}
    </div>
  )
})

export default CollapsibleSection
